<template>
    <v-app class="grey lighten-4">
    <Navbar v-if="loggedIn" />
    <v-main>
      <router-view></router-view>
    </v-main>
    
  </v-app>
</template>

<script>
import Navbar from './components/Navbar'
export default {
  name: 'App',
  data () {
    return {
      loggedIn: false,
    }
  },
  created() {
    if (localStorage.username){
      this.loggedIn = true;
    } else {
      this.loggedIn = false;
    }
    document.title = "Fire Watch 101";
      if (Notification.permission !== "granted"){
        Notification.requestPermission();
      }
    },
  methods: {

  },
  components: {
    Navbar
  },
};
</script>
